import { render, staticRenderFns } from "./AdminExportTargetForm.vue?vue&type=template&id=12b65a24&"
import script from "./AdminExportTargetForm.vue?vue&type=script&lang=js&"
export * from "./AdminExportTargetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports